export const LIMITS_VIEWS = {
    COUNTRIES: 6,
    RETAILERS: 6,
    BRANDS: 3,
    EMAIL_CC: 6,
}